<template>
    <div class="intro-form container">
        <h1>{{appTextLanguage.introform.introTitle[language]}}</h1>
        <span v-if="language == 'en'">
            <strong>#MyMoneyWeek 9th - 13th June 2025</strong>
        </span>
        <span v-if="language == 'cy'">
            <strong>#WythnosFyArian 9eg - 13eg Mehefin 2025</strong> 
        </span>
        <div class="row">
            <div class="col-xs-12" v-html="appTextLanguage.introform.introText[language]">
    
            </div>
        </div>
        <div class="btn-holder">
            <div class="btn-wrap btn-wrap-start registerBtn" @click="openRegistration()">
                <input type="submit" v-model="appTextLanguage.introform.registerButton1[language]" class="btn btn-primary"/>
            </div>
        </div>
        <div class="login_holder">
            <p>{{appTextLanguage.introform.regHaveAccount[language]}}</p>
            <div class="btn-holder">
                <div class="btn-wrap btn-wrap-start loginBtn" @click="openLogin()">
                    <input type="submit" v-model="appTextLanguage.introform.login[language]" class="btn btn-primary"/>
                </div>
            </div>
        </div>
        <modal name="registration-form" id="regModal" 
            reset=true
            transition="fade"
            overlayTransition="fade"
            height="auto"
            scrollable=true
            width="600px"
            pivotY=0.7>
            <div class="modal-close" @click="closeRegistration()">
                <span></span>
            </div>
            <form @submit.prevent="start(form)" key="1" id="registationForm" autocomplete="new-password">
                
                <div class="row inputs">
                    <input type="hidden" name="address_1" v-validate.disable="'required'" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="address_2" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="city" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="postcode" v-validate.disable="'required'" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <h3 class="formCategory">{{appTextLanguage.introform.regTitle[language]}}</h3>

                    <div class="col-12 fullwidth selectbox">
                        <label for="account_type" class="form-label">{{appTextLanguage.account.accountType[language]}}</label>
                        <select v-validate.disable="'required'" v-model.trim="form.account_type" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('account_type') }" name="account_type" id="account_type" autocomplete="new-password">
                            <option value="centre">{{appTextLanguage.account.accountTypeOption1[language]}}</option>
                            <option value="parent">{{appTextLanguage.account.accountTypeOption2[language]}}</option>
                            <option value="other">{{appTextLanguage.account.accountTypeOption3[language]}}</option>
                        </select>
                        <span class="help is-danger"><span v-if="errors.has('account_type')">{{appTextLanguage.account.accountTypeRequired[language]}}</span></span>
                    </div>

                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth" v-if="!centreFallback && form.account_type == 'centre'" key="auto">
                            <label for="centre_lookup" class="form-label">{{appTextLanguage.account.findCentre[language]}}</label>
                            <input class="form-input"
                                :class="{'input': true, 'is-danger': errors.has('centre_lookup') }" 
                                type="text" 
                                name="centre_lookup"
                                id="centre_lookup" 
                                autocomplete="new-password" 
                                v-model="form.centre_search_term"
                                v-validate.disable="'required'"
                                @blur="clearCentreSuggestions"
                                @input="getCentreSuggestions"
                                @keydown.esc="clearCentreSearch"
                                v-bind:placeholder="appTextLanguage.account.centrePlaceholder[language]" 
                                @change="centreSearched"
                            />
                            
                            <ul v-if="centreSuggestions.length > 0" class="suggestions">
                                <li v-for="suggestion in centreSuggestions" :key="suggestion.id" @click="selectSuggestion(suggestion)">
                                    <a>{{ suggestion.name }}</a>
                                </li>
                            </ul>

                            <span class="help not-found" v-if="centreSearchTry" @click="centreAddressFallback">{{appTextLanguage.introform.findCentre[language]}}</span>
                            <span class="help is-danger"><span v-if="errors.has('centre_name') || errors.has('centre_postcode') || errors.has('centre_lookup')">{{appTextLanguage.account.centreAddressRequired[language]}}</span></span>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth fallback" v-if="centreFallback && form.account_type == 'centre'">
                            <div class="col-xs-2" >
                                <label for="centre_name" class="form-label">{{appTextLanguage.account.centreName[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.centre_name" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('centre_name') }" type="text" name="centre_name"
                                    id="centre_name" autocomplete="new-password"/>
                                <span class="help not-found"  @click="centreAddressFallback">{{appTextLanguage.account.autoFindCentre[language]}}</span>
                                <span class="help is-danger"><span v-if="errors.has('centre_name')">{{appTextLanguage.account.centreNameRequired[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="centre_postcode" class="form-label">{{appTextLanguage.account.centrePostcode[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.centre_postcode" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('centre_postcode') }" type="text" name="centre_postcode"
                                    id="centre_postcode" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('centre_postcode')">{{appTextLanguage.account.centrePostcodeRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth fallback" v-if="form.account_type == 'other'">
                            <div class="col-12 fullwidth selectbox">
                                <label for="organisation_type" class="form-label">{{appTextLanguage.account.orgType[language]}}</label>
                                <select v-bind:title="appTextLanguage.account.orgTypeDetail[language]" v-validate.disable="'required'" v-model.trim="form.organisation_type" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('organisation_type') }" name="organisation_type" id="organisation_type" autocomplete="new-password">
                                    <option value="charity">{{appTextLanguage.account.orgTypeOption1[language]}}</option>
                                    <option value="guides">{{appTextLanguage.account.orgTypeOption2[language]}}</option>
                                    <option value="youth_organisation">{{appTextLanguage.account.orgTypeOption3[language]}}</option>
                                    <option value="credit_union">{{appTextLanguage.account.orgTypeOption4[language]}}</option>
                                    <option value="local_authority">{{appTextLanguage.account.orgTypeOption5[language]}}</option>
                                    <option value="bank">{{appTextLanguage.account.orgTypeOption6[language]}}</option>
                                    <option value="children_need">{{appTextLanguage.account.orgTypeOption7[language]}}</option>
                                    <option value="placement">{{appTextLanguage.account.orgTypeOption8[language]}}</option>
                                    <option value="hospital_school">{{appTextLanguage.account.orgTypeOption9[language]}}</option>
                                    <option value="young_enterprise_staff">{{appTextLanguage.account.orgTypeOption10[language]}}</option>
                                    <option value="other">{{appTextLanguage.account.orgTypeOption11[language]}}</option>
                                </select>
                                <span class="help is-danger"><span v-if="errors.has('organisation_type')">{{appTextLanguage.account.orgTypeRequired[language]}}</span></span>
                            </div>

                            <div class="col-xs-2">
                                <label for="organisation" class="form-label">{{appTextLanguage.account.orgName[language]}}</label>
                                <input v-bind:title="appTextLanguage.account.orgNameDetail[language]" v-validate.disable="'required'" v-model.trim="form.organisation" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('organisation') }" type="text" name="organisation"
                                    id="organisation" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('organisation')">{{appTextLanguage.account.orgTypeRequired[language]}}</span></span>
                            </div>
                            
                            <div class="col-xs-2 selectbox">
                                <label for="role" class="form-label">{{appTextLanguage.account.role[language]}}</label>
                                <select v-validate.disable="'required'" v-model.trim="form.role" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('role') }" name="role" id="role" autocomplete="new-password">
                                    <option value="early_years">{{appTextLanguage.account.roleOption1[language]}}</option>
                                    <option value="primary">{{appTextLanguage.account.roleOption2[language]}}</option>
                                    <option value="secondary">{{appTextLanguage.account.roleOption3[language]}}</option>
                                    <option value="teacher_other">{{appTextLanguage.account.roleOption4[language]}}</option>
                                    <option value="teacher_assistant">{{appTextLanguage.account.roleOption5[language]}}</option>
                                    <option value="head">{{appTextLanguage.account.roleOption6[language]}}</option>
                                    <option value="depty">{{appTextLanguage.account.roleOption7[language]}}</option>
                                    <option value="subject_leader">{{appTextLanguage.account.roleOption8[language]}}</option>
                                    <option value="year_group_leader">{{appTextLanguage.account.roleOption9[language]}}</option>
                                    <option value="home_educator">{{appTextLanguage.account.roleOption10[language]}}</option>
                                    <option value="tutor">{{appTextLanguage.account.roleOption11[language]}}</option>
                                    <option value="youth_worker">{{appTextLanguage.account.roleOption12[language]}}</option>
                                    <option value="other">{{appTextLanguage.account.roleOption13[language]}}</option>
                                </select>
                                <span class="help is-danger"><span v-if="errors.has('role')">{{appTextLanguage.account.orgRoleRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>

                    <div class="col-12 fullwidth selectbox multiple">
                        <label for="age_group" class="form-label">{{appTextLanguage.account.ageGroup[language]}}</label>

                        <v-select 
                            multiple 
                            v-bind:title="appTextLanguage.account.ageGroupDetail[language]" 
                            v-validate.disable="'required'" 
                            v-model.trim="form.age_group" 
                            class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('age_group') }" 
                            name="age_group" 
                            id="age_group" 
                            autocomplete="new-password"
                            :reduce="(option) => option.code"
                            :options="[
                                {
                                    code: 'pre_reception', label: appTextLanguage.account.ageOption1[language],
                                },
                                {
                                    code: 'reception', label: appTextLanguage.account.ageOption2[language],
                                },
                                {
                                    code: 'y1', label: appTextLanguage.account.ageOption3[language]
                                },
                                {
                                    code: 'y2', label: appTextLanguage.account.ageOption4[language]
                                },
                                {
                                    code: 'y3', label: appTextLanguage.account.ageOption5[language]
                                },
                                {
                                    code: 'y4', label: appTextLanguage.account.ageOption6[language]
                                },
                                {
                                    code: 'y5', label: appTextLanguage.account.ageOption7[language]
                                },
                                {
                                    code: 'y6', label: appTextLanguage.account.ageOption8[language]
                                },
                                {
                                    code: 'y7', label: appTextLanguage.account.ageOption9[language]
                                },
                                {
                                    code: 'y8', label: appTextLanguage.account.ageOption10[language]
                                },
                                {
                                    code: 'y9', label: appTextLanguage.account.ageOption11[language]
                                },
                                {
                                    code: 'y10', label: appTextLanguage.account.ageOption12[language]
                                },
                                {
                                    code: 'y11', label: appTextLanguage.account.ageOption13[language]
                                },
                                {
                                    code: 'y12', label: appTextLanguage.account.ageOption14[language]
                                },
                                {
                                    code: 'y13', label: appTextLanguage.account.ageOption15[language]
                                },
                                {
                                    code: '18_over', label: appTextLanguage.account.ageOption16[language]
                                }
                            ]">
                        </v-select>
                        <span class="help is-danger"><span v-if="errors.has('age_group')">{{appTextLanguage.account.ageGroupRequired[language]}}</span></span>
                    </div>
                        
                    <div class="col-xs-2">
                        <label for="number_of_students" class="form-label">{{appTextLanguage.account.numberYoung[language]}}</label>
                        <input v-bind:title="appTextLanguage.account.numberYoungDetail[language]" v-validate.disable="'required|numeric'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('number_of_students') }" v-model.trim="form.number_of_students"
                            type="number" min=0 name="number_of_students" id="number_of_students" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('number_of_students')">{{appTextLanguage.account.numberYoungRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2">
                        <label for="number_of_educators" class="form-label">{{appTextLanguage.account.numberEducators[language]}}</label>
                        <input v-bind:title="appTextLanguage.account.numberEducatorsDetail[language]" v-validate.disable="'required|numeric'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('number_of_educators') }" v-model.trim="form.number_of_educators"
                            type="number" min=0 name="number_of_educators" id="number_of_educators" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('number_of_educators')">{{appTextLanguage.account.numberEducatorsRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2 selectbox">
                        <label for="where_did_you_hear" class="form-label">{{appTextLanguage.account.whereDidYouHear[language]}}</label>
                        <select v-validate.disable="'required'" v-model.trim="form.where_did_you_hear" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('where_did_you_hear') }" name="where_did_you_hear" id="where_did_you_hear" autocomplete="new-password">
                            <option value="email_campaign">{{appTextLanguage.account.whereDidYouHearOption1[language]}}</option>
                            <option value="advert">{{appTextLanguage.account.whereDidYouHearOption2[language]}}</option>
                            <option value="event">{{appTextLanguage.account.whereDidYouHearOption3[language]}}</option>
                            <option value="facebook">{{appTextLanguage.account.whereDidYouHearOption4[language]}}</option>
                            <option value="linkedIn">{{appTextLanguage.account.whereDidYouHearOption5[language]}}</option>
                            <option value="twitter ">{{appTextLanguage.account.whereDidYouHearOption6[language]}}</option>
                            <option value="other">{{appTextLanguage.account.whereDidYouHearOption7[language]}}</option>
                            <option value="taken_part_before">{{appTextLanguage.account.whereDidYouHearOption8[language]}}</option>
                            <option value="tv_radio">{{appTextLanguage.account.whereDidYouHearOption9[language]}}</option>
                            <option value="mouth">{{appTextLanguage.account.whereDidYouHearOption10[language]}}</option>
                            <option value="ye_staff">{{appTextLanguage.account.whereDidYouHearOption11[language]}}</option>
                        </select>
                        <span class="help is-danger"><span v-if="errors.has('where_did_you_hear')">{{appTextLanguage.account.whereDidYouHearRequired[language]}}</span></span>
                    </div>
                    
                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')" key="auto">
                            <label for="lookup" class="form-label">{{appTextLanguage.introform.findAddress[language]}}</label>
                            <input class="form-input"
                                :class="{'input': true, 'is-danger': errors.has('lookup') }" type="text" name="lookup"
                                id="lookup" v-validate.disable="'required'" autocomplete="new-password" v-bind:placeholder="appTextLanguage.account.addressPlaceholder[language]" @change="searched"/>
                            <span class="help not-found" v-if="searchTry" @click="addressFallback">{{appTextLanguage.account.findAddress[language]}}</span>
                            <span class="help is-danger"><span v-if="errors.has('address_1') || errors.has('postcode') || errors.has('lookup')">{{appTextLanguage.account.orgAddressRequired[language]}}</span></span>
                        </div>
                        <div class="col-12 fullwidth fallback" v-if="fallback && (form.account_type == 'parent' || form.account_type == 'other')" key="fallback">
                            <div class="col-xs-2" >
                                <label for="address_1" class="form-label">{{appTextLanguage.account.addressLine1[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.address_1" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('address_1') }" type="text" name="address_1"
                                    id="address_1" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('address_1')">{{appTextLanguage.account.addressLine1Required[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="address_2" class="form-label">{{appTextLanguage.account.addressLine2[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.address_2" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('address_2') }" type="text" name="address_2"
                                    id="address_2" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('address_2')">{{appTextLanguage.account.addressLine2Required[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="city" class="form-label">{{appTextLanguage.account.city[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.city" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('city') }" type="text" name="city"
                                    id="city" autocomplete="new-password"/>
                                <span class="help not-found"  @click="addressFallback">{{appTextLanguage.account.autoFindAddress[language]}}</span>
                                <span class="help is-danger"><span v-if="errors.has('city')">{{appTextLanguage.account.cityRequired[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="postcode" class="form-label">{{appTextLanguage.account.postCode[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.postcode" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('postcode') }" type="text" name="postcode"
                                    id="postcode" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('postcode')">{{appTextLanguage.account.postcodeRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>
                    <h3 class="formCategory">{{appTextLanguage.account.personalInfo[language]}}</h3>

                    <div class="col-xs-2">
                        <label for="first_name" class="form-label">{{appTextLanguage.account.firstName[language]}}</label>
                        <input v-validate.disable="'required'" v-model.trim="form.first_name" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('first_name') }" type="text" name="first_name"
                            id="first_name" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('first_name')">{{appTextLanguage.account.firstNameRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2">
                        <label for="last_name" class="form-label">{{appTextLanguage.account.lastName[language]}}</label>
                        <input v-validate.disable="'required'" v-model.trim="form.last_name" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('last_name') }" type="text" name="last_name"
                            id="last_name" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('last_name')">{{appTextLanguage.account.lastNameRequired[language]}}</span></span>
                    </div>

                    <div class="col-12 fullwidth">
                        <label for="email" class="form-label">{{appTextLanguage.account.emailAddress[language]}}</label>
                        <input v-validate.disable="'required|email'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('email') }" v-model.trim="form.email"
                            type="email" name="email" id="email" autocomplete="new-password"/>
                        <span class="help is-danger">{{ errors.first('email') }}</span>
                    </div>
                    
                    <div class="col-xs-2">
                        <label for="password" class="form-label">{{passwordLabel}}</label>
                        <input v-validate.disable="'required|min:6|upCase'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('password') }" v-model.trim="form.password"
                            :type="passwordShow" name="password" id="password" autocomplete="new-password"/>
                        <div class="passwordShow" @click="showPassword" :class="{'showing': passwordShow === 'text'}"></div>
                        <span class="help is-danger">{{ errors.first('password') }}</span>
                    </div>

                    <div class="col-xs-2">
                        <label for="password_repeat" class="form-label">{{appTextLanguage.introform.repeatPassword[language]}}</label>
                        <input v-validate.disable="'required|min:6|upCase'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('password_repeat') }" v-model.trim="form.password_repeat"
                            :type="passwordShowRepeat" name="password_repeat" id="password_repeat" autocomplete="new-password"/>
                        <div class="passwordShow" @click="showPasswordRepeat" :class="{'showing': passwordShowRepeat === 'text'}"></div>
                        <span class="help is-danger">{{ errors.first('password_repeat') }}</span>
                        <span class="help is-danger" v-if="form.password && form.password.length > 0 && form.password_repeat && form.password_repeat.length > 0 && form.password != form.password_repeat">{{ appTextLanguage.introform.matchPassword[language] }}</span>
                    </div>
                </div>
                <div class="row checkboxs">
                    <div class="col-xs-12 checkbox">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" v-model="form.contactPreferences">
                                {{appTextLanguage.account.contactPreferences[language]}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row submit">
                    <div class="col-xs-12 btn-holder">
                        <p class="privacyPolicy">{{appTextLanguage.introform.moreInfo[language]}} <a href="https://www.young-enterprise.org.uk/policies" target="_blank">{{appTextLanguage.introform.privacy[language]}}</a></p>
                        <div class="btn-wrap btn-wrap-start">
                            <input type="submit" v-model="appTextLanguage.introform.registerButton1[language]" class="btn btn-primary"/>
                        </div>
                    </div>
                </div>
            </form>
        </modal>
        <modal name="login-form" id="loginModal" 
            reset=true
            transition="fade"
            overlayTransition="fade"
            height="auto"
            scrollable=true
            width="400px"
            pivotY=0.5>
            <form @submit.prevent="startLogin(formLogin)" key="2" id="loginForm" autocomplete="new-password">
                <div class="row inputs">
                    <h3 class="formCategory">{{appTextLanguage.introform.login[language]}}</h3>
                    <div class="col-12">
                        <span class="help is-danger">{{loginError}}</span>
                    </div>
                    <div class="col-xs-2">
                        <label for="loginemail" class="form-label">{{appTextLanguage.account.emailAddress[language]}}</label>
                        <input v-validate.disable="'required|email'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('loginemail') }" v-model.trim="formLogin.loginemail"
                            type="email" name="loginemail" id="loginemail" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('loginemail')">{{appTextLanguage.account.emailRequired[language]}}</span></span>
                    </div>
                        <div class="col-xs-2">
                        <label for="loginpassword" class="form-label">{{appTextLanguage.introform.password[language]}}</label>
                        <input v-validate.disable="'required'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('loginpassword') }" v-model.trim="formLogin.loginpassword"
                            type="password" name="loginpassword" id="loginpassword" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('loginpassword')">{{appTextLanguage.account.passwordRequired[language]}}</span></span>
                    </div>
                </div>
                <div class="row submit">
                    <div class="col-xs-12 btn-holder">
                        <p class="privacyPolicy">{{appTextLanguage.introform.moreInfo[language]}} <a target="_blank" href="https://www.young-enterprise.org.uk/policies">{{appTextLanguage.introform.privacy[language]}}</a></p>
                        <a class="forgottenPass" @click="forgotPasswordPopup()">{{appTextLanguage.introform.forgotPassword[language]}}</a>
                        <div class="btn-wrap btn-wrap-start">
                            <input type="submit" v-model="appTextLanguage.introform.login[language]" class="btn btn-primary"/>
                        </div>
                    </div>
                </div>
            </form>
        </modal>
        <modal name="forgotten-form" id="forgottenModal" 
          reset=true
          transition="fade"
          overlayTransition="fade"
          height="auto"
          scrollable=true
          width="400px"
          pivotY=0.5>
          <form @submit.prevent="forgotPassword(formReset)" key="5" id="forgottenForm" autocomplete="new-password">
              <div class="row inputs">
                  <h3 class="formCategory">{{appTextLanguage.introform.requestReset[language]}}</h3>
                  <div class="col-12">
                      <span class="help is-danger">{{resetError}}</span>
                  </div>
                  <div class="col-xs-2">
                      <label for="forgotten_email" class="form-label">{{appTextLanguage.account.emailAddress[language]}}</label>
                      <input v-validate.disable="'required|email'" class="form-input"
                          :class="{'input': true, 'is-danger': errors.has('forgotten_email') }" v-model.trim="formReset.forgotten_email"
                          type="email" name="forgotten_email" id="forgotten_email" autocomplete="new-password"/>
                      <span class="help is-danger"><span v-if="errors.has('forgotten_email')">{{appTextLanguage.account.emailRequired[language]}}</span></span>
                  </div>
              </div>
              <div class="row submit">
                  <div class="col-xs-12 btn-holder">
                      <div class="btn-wrap btn-wrap-start">
                          <input type="submit"  v-model="appTextLanguage.introform.requestReset[language]" class="btn btn-primary"/>
                      </div>
                  </div>
              </div>
          </form>
        </modal>
        <modal name="students-form" id="studentsModal" @before-close="doNotClose"
          transition="fade"
          overlayTransition="fade"
          height="auto"
          scrollable=true
          width="400px"
          pivotY=0.5>
          <form @submit.prevent="studentNumber(formStudent)" key="6" id="studentsForm" autocomplete="new-password">
              <div class="row inputs">
                  <h3 class="formCategory">{{appTextLanguage.introform.numberYoung[language]}}</h3>
                  <div class="col-12">
                      <p>{{appTextLanguage.introform.numberYoungDetail[language]}}</p>
                  </div>
                  <div class="col-12">
                      <span class="help is-danger">{{numberError}}</span>
                  </div>
                  <div class="col-xs-2">
                      <label for="number_of_students" class="form-label">{{appTextLanguage.introform.numberYoung[language]}}</label>
                      <input v-validate.disable="'required|numeric'" class="form-input"
                          :class="{'input': true, 'is-danger': errors.has('number_of_students') }" v-model.trim="formStudent.number_of_students"
                          type="number" min=0 name="number_of_students" id="number_of_students" autocomplete="new-password"/>
                      <span class="help is-danger"><span v-if="errors.has('number_of_students')">{{appTextLanguage.account.numberYoungRequired[language]}}</span></span>
                  </div>
              </div>
              <div class="row submit">
                  <div class="col-xs-12 btn-holder">
                      <div class="btn-wrap btn-wrap-start">
                          <input type="submit" v-model="appTextLanguage.introform.submit[language]" class="btn btn-primary"/>
                      </div>
                  </div>
              </div>
          </form>
        </modal>
    </div>
</template>
<script>
    const START_VIDEO_ID = 1;

    export default {
        name: 'IntroForm',
        data: function () {
            return {
                language: null,
                appTextLanguage: null,
                form: {
                    first_name: '',
                    last_name: '',
                    organisation: null,
                    organisation_type: null,
                    age_group: '',
                    number_of_students: null,
                    number_of_educators: null,
                    where_did_you_hear: null,
                    role: null,
                    lookup: '',
                    address_1: '',
                    address_2: '',
                    city: '',
                    postcode: '',
                    email: null,
                    password: null,
                    password_repeat: null,
                    contactPreferences: false,
                    account_type: null,
                    centre_id: null,
                    centre_urn: null,
                    centre_name: null,
                    centre_postcode: null,
                    centre_search_term: '',
                },
                formLogin: {
                    loginemail: null,
                    loginpassword: null
                },
                formReset:{
                    forgotten_email: null,
                },
                formStudent: {
                    number_of_students: null
                },
                schools: null,
                control: null,
                loginError: null,
                resetError: null,
                numberError: null,
                passwordShow: 'password',
                passwordShowRepeat: 'password',
                searchTry: false,
                centreSearchTry: false,
                fallback: false,
                centreFallback: false,
                passwordLabel: 'Create Password',
                centreSuggestions: [],
                centreSelected: null,
                timeoutId: null,
            }
        },
        methods: {
            addressFallback() {
                // Show fallback fields
                this.fallback = !this.fallback;
                console.log(this.fallback);
                if(!this.fallback) {
                    setTimeout(() => {
                        this.loqateSetup();
                    }, 1500);
                }
            },
            centreAddressFallback() {
                // Show centre fallback fields
                this.centreFallback = !this.centreFallback;
                console.log(this.centreFallback);
                if(!this.centreFallback) {
                    setTimeout(() => {
                        console.log('centreAddressFallback');
                    }, 1500);
                }
            },
            searched() {
                this.searchTry = true;
            },
            centreSearched() {
                this.centreSearchTry = true;
            },
            showPassword() {
                this.passwordShow = this.passwordShow === 'password' ? 'text' : 'password';
            },
            showPasswordRepeat() {
                this.passwordShowRepeat = this.passwordShowRepeat === 'password' ? 'text' : 'password';
            },
            doNotClose(event) {
                event.stop();
            },
            closeRegistration() {
                this.$modal.hide('registration-form');
            },
            openRegistration() {
                this.$modal.show('registration-form');

                this.loqateSetup();
            },
            loqateSetup() {
                let fields = [
                    { element: "lookup", field: "{Line1}{, {Line2}}{, {Line3}}{, {City}}{, {PostalCode}}", mode: pca.fieldMode.SEARCH | pca.fieldMode.POPULATE },
                    { element: "address_1", field: "Line1", mode: pca.fieldMode.POPULATE},
                    { element: "address_2", field: "Line2", mode: pca.fieldMode.POPULATE},
                    { element: "postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE},
                    { element: "city", field: "City", mode: pca.fieldMode.POPULATE}
                ];
                let options = {
                    key: process.env.LOQATE_KEY
                }
                this.control = new pca.Address(fields, options);
                setTimeout(() => {
                    this.control.load();
                }, 500);

                let vm = this;
                this.control.listen("populate", function(address, variations) {
                    vm.form.postcode = address.PostalCode;
                    vm.form.address_1 = address.Line1;
                    vm.form.address_2 = address.Line2;
                    vm.form.city = address.City;
                });
            },
            openLogin() {
                this.$modal.show('login-form');                
            },
            persistFormData(formData) {
                console.log(formData);
                // Send to WP
                let data = {};
                data.email = formData.email;
                data.password = formData.password;
                data.first_name = formData.first_name;
                data.last_name = formData.last_name;
                data.organisation_name = formData.organisation;
                data.organisation_type = formData.organisation_type;
                data.role = formData.role;
                data.age_group = formData.age_group;
                data.number_of_students = formData.number_of_students;
                data.address_1 = this.form.address_1;
                data.address_2 = this.form.address_2;
                data.city = this.form.city;
                data.postcode = this.form.postcode;
                data.contact_preference = formData.contactPreferences;

                data.account_type = formData.account_type;
                data.number_of_educators = formData.number_of_educators;
                data.where_did_you_hear = formData.where_did_you_hear;

                // only send this data if 'fallback' fields weren't visible
                data.centre_id = (!this.centreFallback ? formData.centre_id : null);
                data.centre_urn = (!this.centreFallback ? formData.centre_urn : null);
                data.establishment_name = (!this.centreFallback ? formData.centre_search_term : null);
                
                // only send this data if 'fallback' fields were visible
                data.centre_name = (this.centreFallback ? formData.centre_name : null);
                data.centre_postcode = (this.centreFallback ? formData.centre_postcode : null);

                this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/register', data, {timeout: 60000, chained: true}).then(function (response) {
                    console.log(response.data);
                    if(response.data.code == 200) {
                        // var existingUser = false;
                        // if(response.data.existing_user != null){
                        //     existingUser = true;
                        // }
                        // Log user in
                        let logindata = {};
                        logindata.username = formData.email;
                        logindata.password = formData.password;
                        this.$http.post(process.env.WP_ENDPOINT + 'jwt-auth/v1/token', logindata, {timeout: 60000, chained: true}).then(function (response) {
                            console.log(response.data);
                            if(response.data.token != null) {
                                // Successfull - Now try to log user in
                                this.$modal.hide('registration-form');
                                // this.$router.go();

                                
                                delete data.password;

                                this.$store.commit('setAccountInfo', data);
                                this.$store.commit('setBearerToken', response.data.token);
                                if(response.data.type == 'all_through') {
                                    response.data.type = 'primary';
                                }
                                this.$store.commit('setMMWType', response.data.type);
                               
                                if(response.data.request_number != null && response.data.request_number == true){
                                    this.$toasted.show(this.appTextLanguage.introform.regsuccess[this.language], {
                                        duration: 6000,
                                        position: 'top-center',
                                        type: "success",
                                        action: {
                                            text: this.appTextLanguage.introform.close[this.language],
                                            onClick : (e, toastObject) => {
                                                toastObject.goAway(0);
                                            }
                                        }
                                    });
                                    this.$modal.show('students-form');
                                    this.$global.loading = false;
                                } else {
                                    this.$toasted.show(this.appTextLanguage.introform.regsuccess1[this.language], {
                                        duration: 6000,
                                        position: 'top-center',
                                        type: "success",
                                        action: {
                                            text: this.appTextLanguage.introform.close[this.language],
                                            onClick : (e, toastObject) => {
                                                toastObject.goAway(0);
                                            }
                                        }
                                    });
                                    // scroll to top.
                                    console.log(this.$vuebar);
                                    this.$vuebar.scrollTo(0, 0);
                                    this.$emit('loggedin', true);
                                }

                                // // Existing user password message.
                                // if(existingUser) {
                                //     this.$toasted.show('Please note, the password for your Young Enterprise account has been changed to the password provided.', {
                                //         duration: 6000000,
                                //         position: 'top-center',
                                //         type: "info",
                                //         action: {
                                //             text: 'CLOSE',
                                //             onClick : (e, toastObject) => {
                                //                 toastObject.goAway(0);
                                //             }
                                //         }
                                //     });
                                // }

                                return;
                            }
                        },function (response) {
                            // Error
                            console.log(response.data);
                            if(response.data != null && response.data != '' && response.data.data.status == '403') {
                                // Login failed
                                this.loginError = this.appTextLanguage.introform.incorrectEmail[this.language];
                            } else {
                                this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                            }

                        });
                    }
                },function (response) {
                    // Error
                   if(response.data != null && response.data != '' && response.data.data.status == 400){
                        var field = response.data.data.field;
                        var message = response.data.message;
                        if(field == 'email') {
                            this.$validator.errors.add({
                                id: 'email',
                                field: 'email',
                                msg: this.appTextLanguage.account.emailExistsReg[this.language],
                                scope: this.$options.scope,
                            });
                        }else if(field == 'password') {
                            this.$validator.errors.add({
                                id: 'password',
                                field: 'password',
                                msg: message,
                                scope: this.$options.scope,
                            });
                        }else if (field == 'register') {
                            this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                        }else if (field == 'password_existing') {
                            this.$validator.errors.add({
                                id: 'password',
                                field: 'password',
                                msg: this.appTextLanguage.introform.validationPassword[this.language],
                                scope: this.$options.scope,
                            });
                            this.$toasted.show(this.appTextLanguage.introform.existingReg[this.language], {
                                duration: 6000000,
                                position: 'top-center',
                                type: "info",
                                action: {
                                    text: this.appTextLanguage.introform.close[this.language],
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                }
                            });
                        }
                    } else {
                        this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                    }
                    setTimeout(() => {
                        this.$global.loading = false;
                    }, 1000);
                    
                });
            },
            start(formData) {
                this.$validator.extend('upCase', {
                    getMessage: () => this.appTextLanguage.introform.passRequirement[this.language],
                    validate: value => value.match(/[A-Z]/g) !== null
                });
                this.$validator.validateAll().then((result) => {
                    console.log('validate');
                    console.log(result);

                    if (result)
                    {
                        // all valid
                        this.persistFormData(formData);
                    }
                    else
                    {
                        console.log('errors');
                        const errors = this.$validator.errors;
                        console.log(errors); // This object contains field names as keys and error messages as values.
                    }
                    // errors to correct
                });

            },
            startLogin(formData) {
                this.loginError = null;
                this.$validator.validateAll().then((result) => {

                    if (result) {
                        // all valid
                        this.loginSubmit(formData);
                    }
                    // errors to correct
                });

            },
            loginSubmit(formData) {
                console.log(formData);

                // Send to WP
                let data = {};
                data.username = formData.loginemail;
                data.password = formData.loginpassword;

                this.$http.post(process.env.WP_ENDPOINT + 'jwt-auth/v1/token', data, {timeout: 60000}).then(function (response) {
                    console.log('response.data');
                    console.log(response.data);
                    if(response.data.token != null) {
                        // Successfull - Now try to log user in
                        this.$store.commit('setBearerToken', response.data.token);
                        if(response.data.type == 'all_through') {
                            response.data.type = 'primary';
                        }
                        this.$store.commit('setMMWType', response.data.type);
                        this.$store.commit('setAccountInfo', response.data.account_info);
                        this.$store.commit('setTrackingInfo', response.data.userchoice);

                        this.$modal.hide('login-form');
                
                        this.$toasted.show(this.appTextLanguage.introform.loginSuccess[this.language], {
                            duration: 6000,
                            position: 'top-center',
                            type: "success",
                            action: {
                                text: this.appTextLanguage.introform.close[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        });


                        // See if the student pop-up needs to show
                        if(response.data.request_number != null && response.data.request_number == true){
                            
                                var accountInfo = this.$store.getters.getAccountInfo;
                                if(accountInfo != null) {
                                    this.formStudent.number_of_students = accountInfo.number_of_students;

                                }
                            this.$modal.show('students-form');
                        } else {
                            // scroll to top.
                            console.log(this.$vuebar);
                            this.$vuebar.scrollTo(0, 0);
                            this.$emit('loggedin', true);
                        }

                        return;
                    } else if (response.data.invalid_role != null){
                        this.loginError = this.appTextLanguage.introform.incorrectEmail[this.language];
                    }
                },function (response) {
                    // Error
                    console.log(response.data);
                    if(response.data != null && response.data != '' && response.data.data.status == '403') {
                        // Login failed
                        this.loginError = this.appTextLanguage.introform.incorrectEmail[this.language];
                    } else {
                        this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                    }

                });
            },
            forgotPasswordPopup() {
                // Validate
                this.$modal.hide('login-form');
                this.$modal.show('forgotten-form');               
            },
            forgotPassword(form) {
                this.$validator.validateAll().then((result) => {

                    if (result) {
                        // all valid
                        var data = {};
                        data.user_login = form.forgotten_email;
                        data.language = this.language;
                        this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/lostpassword', data, {timeout: 60000}).then(function (response) {
                            this.$modal.hide('forgotten-form');
                            this.$toasted.show(this.appTextLanguage.introform.passresetInstructions[this.language], {
                                duration: 6000,
                                position: 'top-center',
                                type: "success",
                                action: {
                                    text: this.appTextLanguage.introform.close[this.language],
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                }
                            });
                        },function (response) {
                            this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                        });
                    }
                // errors to correct
                });
            },
            studentNumber(form) {

               
               

                this.$validator.validateAll().then((result) => {

                    if (result) {
                        console.log(form);
                        // all valid
                        var data = {};
                        data.number_students = form.number_of_students;
                        console.log(data);
                        this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/updatestudents', data, {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getBearerToken
                            },
                            timeout: 60000
                        }).then(function (response) {
                            console.log(response.data);
                            if(response.data.code == 200) {
                                // 
                                this.$store.commit('setNumberOfStudents', data.number_students);
                                this.$modal.hide('students-form');
                                this.$toasted.show(this.appTextLanguage.introform.recordUpdate[this.language], {
                                    duration: 6000,
                                    position: 'top-center',
                                    type: "success",
                                    action: {
                                        text: this.appTextLanguage.introform.close[this.language],
                                        onClick : (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    }
                                });
                                // scroll to top.
                                console.log(this.$vuebar);
                                this.$vuebar.scrollTo(0, 0);
                                this.$emit('loggedin', true);
                            }
                        },function (response) {
                            // Error
                            console.log(response.data);
                            this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                        });
                    }
                // errors to correct
                });
            },
            getCentreSuggestions()
            {
                this.centreSuggestions = [];

                // Clear any pending timeouts
                clearTimeout(this.timeoutId);

                if (!this.form.centre_search_term) return;

                // Schedule the API call after 300 mseconds
                this.timeoutId = setTimeout(async () => {
                    this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/school-suggestions', {centre_name: this.form.centre_search_term}, {timeout: 60000, hidden:true, chained: true}).then(function (response)
                    {    
                        console.log(response.data);

                        if(response.data.code == 200)
                        {
                            console.log('success');
                            this.centreSuggestions = response.data.suggestions;

                            console.log(this.centreSuggestions);
                        }

                        console.log('test');
                        this.$global.loading = false;

                    },function (response) {
                        // error callback
                        console.log('error');
                        this.$global.loading = false;
                    });
                }, 300);
            },
            clearCentreSuggestions() {
                // Clear any pending timeouts
                clearTimeout(this.timeoutId);

                // small timeout so it doesn't remove the suggestions before the 'onclick' event
                setTimeout(() => 
                {
                    this.centreSuggestions = [];
                    
                    // shool name was manually changed after selected
                    if(this.centreSelected && this.form.centre_search_term != this.centreSelected)
                    {
                        this.form.centre_search_term = this.centreSelected;
                    }

                    // empty search field if no option was selected from the drop-down
                    console.log(this.form.centre_id);
                    if(!this.form.centre_id)
                    {
                        this.form.centre_search_term = '';
                    }    
                }, 400);
            },
            clearCentreSearch() {
                this.form.centre_search_term = '';
                this.centreSuggestions = [];
            },
            selectSuggestion(suggestion)
            {
                this.centreSelected = suggestion.name;
                console.log('selectSuggestion');
                console.log(suggestion);
                this.form.centre_search_term = suggestion.name;
                this.form.centre_id = suggestion.id;
                this.form.centre_urn = suggestion.urn;
                this.centreSuggestions = [];
            },
        },
        created: function () {

            this.appTextLanguage = this.$store.getters.getAppTextLanguage;
            console.log(this.appTextLanguage);
            this.language = this.$store.getters.getLanguage;

            this.passwordLabel = this.appTextLanguage.introform.createPassword[this.language];

            // const dictionary = {
            //     en: {
            //         messages:{
            //             numeric: () => 'This field can only contain numeric characters.',
            //             required: field => 'The ' + field.replace('forgotten_email', 'email').replace(/_/g, ' ').replace('login', '').replace('resetemail', 'email').replace('resetpassword', 'new password') +  ' field is required.',
            //             min: () => 'Password must be at least 6 characters.'
            //         }
            //     }
            // };

            // this.$validator.localize(dictionary);

            this.$validator.extend('postcode', {
                getMessage: field => 'The ' + field + ' ' + this.appTextLanguage.introform.invalidPostcode[this.language],
                validate: function (value) {
                    return /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})/i.test(value)
                },
            });

        },
        mounted() {
            let loqateScript = document.createElement('script')
            loqateScript.setAttribute('src', 'https://services.postcodeanywhere.co.uk/js/address-3.91.js')
            document.head.appendChild(loqateScript)

            // console.log(this.centres);

            
        },
        watch: {
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;
                this.passwordLabel = this.appTextLanguage.introform.createPassword[this.language];
                document.documentElement.lang = this.language;
            },
            'form.account_type': function () {
                // make sure the script is re-linked to the field once it is created
                if(this.form.account_type == 'parent' || this.form.account_type == 'other')
                {
                    setTimeout(() => {
                        this.loqateSetup();
                    }, 1500);
                }
            }
        }
    }


</script>

<!-- "scoped" attribute limits CSS to this component only -->
<style scoped>
    @import "https://services.postcodeanywhere.co.uk/css/address-3.91.css";
</style>



// WEBPACK FOOTER //
// src/components/forms/IntroForm.vue